import Session from '../core/session'
import Config from '../core/config'

export class CookieCollector {
  private static instance: CookieCollector

  private constructor() {}

  public static getInstance(): CookieCollector {
    if (!CookieCollector.instance) {
      CookieCollector.instance = new CookieCollector()
    }
    return CookieCollector.instance
  }

  /**
   * Track cookie consent (call this manually from consent banner)
   */
  public trackConsent(data: {
    status: 'accepted' | 'rejected' | 'pending'
    necessary?: boolean
    functional?: boolean
    analytics?: boolean
    marketing?: boolean
  }): void {
    Session.trackEvent('cookie_consent', {
      action: data.status,
      categories: {
        necessary: data.necessary !== false, // Default true
        functional: data.functional || false,
        analytics: data.analytics || false,
        marketing: data.marketing || false
      }
    })

    if (Config.isDebug()) {
      console.log('[RadarSnap] Cookie consent tracked:', data.status)
    }
  }

  /**
   * Track cookie operations (when cookie is set)
   */
  public trackCookieSet(name: string, size: number): void {
    Session.trackEvent('storage_operation', {
      storage_type: 'cookies',
      operation: 'set',
      key: name,
      size: size
    })
  }

  /**
   * Analyze current cookies and categorize them
   */
  public analyzeCookies(): void {
    try {
      const cookies = document.cookie.split(';')
      const cookieData: Record<string, any> = {
        total_count: cookies.length,
        categories: {} as Record<string, number>,
        total_size: new Blob([document.cookie]).size
      }

      cookies.forEach(cookie => {
        const [name] = cookie.trim().split('=')
        if (name) {
          const category = this.categorizeCookie(name)
          cookieData.categories[category] = (cookieData.categories[category] || 0) + 1
        }
      })

      Session.trackEvent('cookie_analysis', cookieData)

      if (Config.isDebug()) {
        console.log('[RadarSnap] Cookie analysis:', cookieData)
      }
    } catch (error) {
      if (Config.isDebug()) {
        console.warn('[RadarSnap] Failed to analyze cookies:', error)
      }
    }
  }

  /**
   * Categorize cookie based on name patterns
   */
  private categorizeCookie(name: string): string {
    const lowerName = name.toLowerCase()

    // Essential cookies
    if (lowerName.includes('session') || lowerName.includes('csrf') || lowerName.includes('auth')) {
      return 'essential'
    }

    // Analytics cookies
    if (lowerName.includes('_ga') || lowerName.includes('_gid') || lowerName.includes('analytics')) {
      return 'analytics'
    }

    // Marketing cookies
    if (lowerName.includes('_fbp') || lowerName.includes('_fbc') || lowerName.includes('marketing')) {
      return 'marketing'
    }

    // Functional cookies
    if (lowerName.includes('pref') || lowerName.includes('lang') || lowerName.includes('theme')) {
      return 'functional'
    }

    return 'other'
  }
}

export default CookieCollector.getInstance()